import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import useColor from 'views/client/reports/hooks/useColor';
import {ReportChart} from 'views/client/reports/components/Chart/types';

interface Props extends React.ComponentProps<'div'> {
  chart: ReportChart;
  legend?: boolean;
}

export const Chart: React.FC<Props> = ({chart, legend, ...props}) => {
  const {getColor} = useColor();
  const data = React.useMemo(() => {
    const transformedData: any[] = [];

    chart.axis.forEach((axisValue, index) => {
      const entry: any = {name: axisValue};

      chart.data.forEach((dataItem) => {
        entry[dataItem.label] = dataItem.values[index];
      });

      transformedData.push(entry);
    });

    return transformedData;
  }, []);

  const bars = React.useMemo(
    () =>
      chart.data
        ? chart.data.map((d, i) => ({
            dataKey: d.label,
            stackId: d.groupId,
            fill: d.color || getColor(i),
          }))
        : [],
    [chart.data],
  );

  return (
    <div {...props}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{}}>
          <CartesianGrid strokeDasharray="3" />
          <XAxis dataKey="name" />
          <YAxis axisLine={false} width={45} />
          <Tooltip />
          {bars.map((b, i) => (
            <Bar
              key={i}
              dataKey={b.dataKey}
              stackId={b.stackId}
              fill={b.fill}
              barSize={12}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
